(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CronogramaFungicidasAplicacaoCtrl', CronogramaFungicidasAplicacaoController);

  CronogramaFungicidasAplicacaoController.$inject = [
    '$element',
    'MessagesService',
    'CronogramaFungicidasService',
    'LoadingService',
    'RecomendacoesService',
    'UnidadesService',
    '$scope'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function CronogramaFungicidasAplicacaoController($element, MessagesService, CronogramaFungicidasService,
    LoadingService, RecomendacoesService, UnidadesService, $scope) {
    const vm = this;

    // Controller data
    vm.isEditing = false;
    vm.editAplicacao = null;
    vm.loadingItems = false;
    vm.datepickerDataEstimada = false;
    vm.datepickerOptions = {
      showWeeks: false
    };
    vm.datepickerMinDate = null;
    vm.newItem = null;
    vm.working = false;
    // bound by component
    vm.items = [];
    vm.cronograma = null;
    vm.aplicacao = null;
    vm.index = 0;
    vm.searchItem = '';

    // Bindable methods
    vm.canEdit = canEdit;
    vm.canDisablePerforming = canDisablePerforming;
    vm.canEnablePerforming = canEnablePerforming;
    vm.willNotPerform = willNotPerform;
    vm.willPerform = willPerform;
    vm.searchItems = searchItems;
    vm.addItem = addItem;
    vm.cancelChanges = cancelChanges;
    vm.removeItem = removeItem;
    vm.saveChanges = saveChanges;
    vm.fixAbreviatura = _.memoize(fixAbreviatura);
    vm.wasAppliedLate = wasAppliedLate;
    vm.updateUnidade = updateUnidade;

    // Function declarations
    function initialize() {
      vm.editAplicacao = {
        data_estimada: moment(vm.aplicacao.data_estimada).toDate(),
        observacoes: vm.aplicacao.observacoes,
        items_attributes: []
      };

      vm.aplicacao.items.forEach((item) => {
        addItem(item.item_estoque, item.dose, item.unidade.descricao);
      });

      vm.datepickerMinDate = moment(vm.cronograma.data_plantio).toDate();

      if (!vm.aplicacao.id) {
        vm.isEditing = true;
        vm.editAplicacao.numero_aplicacao = vm.aplicacao.numero_aplicacao + 1;
      }

      const dataAplicacao = (vm.aplicacao.data_fim_aplicacao || vm.aplicacao.data_estimada);
      vm.aplicacao.diasEntreEmergenciaEAplicacao = dataAplicacao &&
        moment(dataAplicacao).diff(moment(vm.cronograma.data_emergencia), 'days');
    }

    function canEdit() {
      return ['delayed', 'pending'].includes(vm.aplicacao.status) && !vm.isEditing;
    }

    function canDisablePerforming() {
      return !['applied', 'will_not_perform'].includes(vm.aplicacao.status) && !vm.isEditing;
    }

    function canEnablePerforming() {
      return vm.aplicacao.status === 'will_not_perform' &&
        !vm.cronograma.parameters.some((aplicacao, index) => index > vm.index && aplicacao.status === 'applied');
    }

    function willNotPerform() {
      MessagesService.confirm('Você tem certeza que essa aplicação não será realizada?')
        .then(() => {
          LoadingService.showLoading();
          return CronogramaFungicidasService.willNotPerform(vm.aplicacao);
        })
        .then(() => {
          vm.onUpdate({ aplicacao: vm.aplicacao });
        })
        .catch((error) => {
          if (error && typeof error !== 'string') {
            console.error(error);
            MessagesService.alert('Erro ao desativar aplicação. Tente novamente.');
          }
        })
        .finally(() => {
          LoadingService.hideLoading();
          setTimeout(() => angular.element('body').addClass('modal-open'), 500);
        });
    }

    function willPerform() {
      MessagesService.confirm('Você tem certeza que quer readicionar essa aplicação ao cronograma?')
        .then(() => {
          LoadingService.showLoading();
          return CronogramaFungicidasService.willPerform(vm.aplicacao);
        })
        .then(() => {
          vm.onUpdate({ aplicacao: vm.aplicacao });
        })
        .catch((error) => {
          if (error && typeof error !== 'string') {
            console.error(error);
            return MessagesService.alert('Erro ao reativar aplicação. Tente novamente.');
          }
        })
        .finally(() => {
          LoadingService.hideLoading();
          setTimeout(() => angular.element('body').addClass('modal-open'), 500);
        });
    }

    function searchItems($select) {
      vm.searchItem = $select.search;
      vm.items = null;
      if (vm.searchItem.length >= 3) {
        vm.loadingItems = true;
        RecomendacoesService.listItemsBalance({
          descricao: $select.search
        }, null).then(function(data) {
          let result = data.data || [];
          result = result.map((item) => {
            item.item_id = item.id;
            item.tipo_item = item.tipo;
            return item;
          });
          vm.items = result.filter((item) => !vm.editAplicacao.items_attributes
            .find((aplicacaoItem) => aplicacaoItem.item.item_id === item.item_id));
        })
          .catch(function(error) {
            console.error('Erro ao buscar produtos', error);
            MessagesService.alert('Erro ao carregar produtos');
          })
          .finally(function() {
            vm.loadingItems = false;
          });
      }
    }

    function setDataByLastItem(currentItem) {
      const newData = {};
      const indexOfCurrentCronograma = vm.cronograma.parameters.map((item) => item.id).indexOf(vm.aplicacao.id);

      if (indexOfCurrentCronograma === 0) {
        return newData;
      }

      const parametersIndex = (
        indexOfCurrentCronograma === -1 ?
          vm.cronograma.parameters.length :
          indexOfCurrentCronograma
      ) - 1;
      const lastAplicationIntems = vm.cronograma.parameters[parametersIndex].items;

      const itemFiltered = lastAplicationIntems.find((item) => (
        item.item_estoque.id[0] === currentItem.id[0] &&
        item.item_estoque.id[1] === currentItem.id[1]
      ));

      if (itemFiltered) {
        newData.dose = itemFiltered.dose;
        newData.unidade = itemFiltered.unidade;
      }

      return newData;
    }

    function addItem(
      newItem = vm.newItem,
      dose = 0,
      unidade
    ) {
      const newItenParams = setDataByLastItem(newItem);

      if (Object.keys(newItenParams).length) {
        dose = newItenParams.dose;
        unidade = newItenParams.unidade.descricao;
      }

      unidade = UnidadesService.getMeasureUnitysFromDescription(unidade || newItem.unidade.descricao);
      const unidades = UnidadesService.getUnidadesCompativeis(unidade);
      vm.editAplicacao.items_attributes.push({
        item: newItem,
        item_id: newItem.item_id,
        item_tipo: newItem.tipo_item,
        unidade_nome_sistema: unidade.nomeSistema,
        unidades,
        unidade,
        dose: +dose
      });
      vm.newItem = null;
    }

    function cancelChanges() {
      const reset = () => {
        vm.isEditing = false;
        vm.$onInit();
        $scope.form.$setPristine();
      };

      if ($scope.form.$dirty) {
        return MessagesService.confirm('Suas modificações serão perdidas. Você tem certeza que deseja cancelar?')
          .then(() => {
            if (!vm.aplicacao.id) {
              return vm.cancelNewAplicacao({ schedule: vm.cronograma });
            }
            reset();
          })
          .finally(() => {
            setTimeout(() => angular.element('body').addClass('modal-open'), 500);
          });
      }
      if (!vm.aplicacao.id) {
        return vm.cancelNewAplicacao({ schedule: vm.cronograma });
      }
      reset();
    }

    function removeItem(item) {
      const index = vm.editAplicacao.items_attributes.indexOf(item);
      if (index > -1) {
        vm.editAplicacao.items_attributes.splice(index, 1);
      } else {
        MessagesService.alert('Erro ao remover produto. Tente novamente.');
      }
    }

    function saveChanges() {
      return MessagesService.confirm('Você confirma estas alterações?')
        .then(() => {
          vm.working = true;
          if (vm.aplicacao.id) {
            return CronogramaFungicidasService.saveAplicacao(vm.aplicacao.id, vm.editAplicacao);
          }
          return CronogramaFungicidasService.createAplicacao(vm.cronograma.id, vm.editAplicacao);
        })
        .then(() => {
          if ($scope.form.dataEstimada.$dirty) {
            vm.onUpdateSchedule();
          } else {
            vm.onUpdate({ aplicacao: vm.aplicacao });
          }
          vm.isEditing = false;
          $scope.form.$setPristine();
        })
        .catch((error) => {
          showError(error);
        })
        .finally(() => {
          vm.working = false;
          setTimeout(() => angular.element('body').addClass('modal-open'), 500);
        });
    }

    function showError(error) {
      let mensagemErro = 'Falha ao salvar aplicação, tente novamente.';
      if (error && typeof error.data === 'object') {
        const errors = _.values(error.data);
        mensagemErro = _.isEmpty(errors) ? mensagemErro : `Falha ao salvar aplicação: <br> ${errors.join(', ')}`;
      }
      MessagesService.alert(mensagemErro);
    }

    function wasAppliedLate() {
      if (vm.aplicacao.status === 'applied') {
        const { data_fim_aplicacao: appliedDate } = vm.aplicacao;
        const { data_estimada: estimatedDate } = vm.aplicacao;

        return moment(appliedDate).isAfter(estimatedDate);
      }
      return false;
    }

    function fixAbreviatura(abreviatura) {
      return abreviatura.trim().toLowerCase();
    }

    function updateUnidade(produto, event) {
      preventDefault(event);

      produto.unidade_nome_sistema = produto.unidade.nomeSistema;
    }

    // Controller logic
    vm.$postLink = function $postLink() {
      $element.addClass('vertical-timeline-block');
    };

    vm.$onInit = initialize;

    vm.$onChanges = function $onChanges(changes) {
      if (changes.aplicacao && !changes.aplicacao.isFirstChange()) {
        initialize();
      }
    };
  }
}());
